import React from 'react'
import Navbar from './Navbar'
import Footer from './Footer'

function Services() {
  return (

    <>
    <Navbar/>
    <div className="vh-100 d-flex justify-content-center align-items-center">
        SERVICES
    </div>

    <Footer/>
    </>
  )
}

export default Services